"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DocumentCardTitle_base_1 = require("./DocumentCardTitle.base");
var DocumentCardTitle_styles_1 = require("./DocumentCardTitle.styles");
exports.DocumentCardTitle = Utilities_1.styled(DocumentCardTitle_base_1.DocumentCardTitleBase, DocumentCardTitle_styles_1.getStyles, undefined, { scope: 'DocumentCardTitle' });
//# sourceMappingURL=DocumentCardTitle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardTitle.js
// module id = 965
// module chunks = 0